export default url => {
  window.location.href = url;
};
